<style scoped lang="sass">
</style>
<template>
  <div class="page">
    <div class="padded">
      <form @submit.prevent="save">
        <div>
          <span v-if="$root.currentUserSolvent">Subscription ends: {{$root.currentUserSolventThrough}}</span>
          <span v-if="!$root.currentUserSolvent">Not subscribed</span>
        </div>
        <div>
          <a href="#" @click.prevent="$root.togglePaymentModal">Manage Subscription</a>
        </div>
        <div class="input-group">
          <label>EMAIL</label>
          <input type="text" v-model="user.email" class="input-control" disabled="disabled">
        </div>
        <div class="input-group">
          <label>FIRST NAME</label>
          <input type="text" v-model="user.first_name" class="input-control">
        </div>
        <div class="input-group">
          <label>LAST NAME</label>
          <input type="text" v-model="user.last_name" class="input-control">
        </div>
        <div class="input-group">
          <a href="#" @click.prevent="showPassword = true" v-if="!showPassword">Change password?</a>
        </div>
        <div class="input-group" v-if="showPassword">
          <label>PASSWORD</label>
          <input type="password" v-model="user.password_1" class="input-control">
        </div>
        <input type="submit" class="button positive" value="Save">
      </form>
    </div>
  </div>
</template>
<script>
import api from '../api';

export default {
  name: 'Account',
  data() {
    return {
      showPassword: false,
      user: {}
    };
  },
  created() {
    this.$store.dispatch('configNavigation', {leftEnabled: true, leftRoute: {name: 'dashboard'}, leftImg: 'icon-back.svg'});
    this.user = Object.assign({}, this.$store.getters.currentUser);
  },
  methods: {
    save() {
      api.User.update({params: {id: this.user.id, user: this.user}})
        .then(user => {
          this.$store.commit('logIn', user);
          this.$router.push({name: 'dashboard'});
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
